import Swal, { SweetAlertIcon } from 'sweetalert2';



export class alerts {


    static basicAlert(title: string, text: string, icon: SweetAlertIcon) {

        Swal.fire(title, text, icon);
    }





    static confirtmAlert(title: string, text: string, confirmButtronText: string) {
        return Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: confirmButtronText
        })
    }




    static confirtmAlertOneButton(title: string, text: string, confirmButtronText: string) {
        return Swal.fire({
            title: title,
            text: text,
            icon: 'warning',

            confirmButtonColor: '#3085d6',

            confirmButtonText: confirmButtronText
        })
    }




    static information(title: string, text: string, confirmButtronText: string, compania: string) {
        return Swal.fire({
            //icon: 'info',
            html:
           ' <p style="color:black;font-size:15px;text-align: justify"><strong style="color:black;  text-align: center;font-size:20px">INFORMATIVO</strong><br> Reciba un cordial saludo de quienes conformamos la Compañía de transporte escolar  ' + compania + ', a la vez que ponemos a su disposición nuestra plataforma digital que nos va a permitir optimizar el proceso de inscripción para el servicio de transporte estudiantil para el periodo 2025 - 2026; por lo que agradeceremos llenar toda la información requerida para oficializar la inscripción de su representado. <br><br>Según a lo que establece la normativa vigente en el <b> ACUERDO Nro. MINEDUC-MINEDUC-2022-00041-A: NORMATIVA DE TRANSPORTE ESCOLAR PARA LAS INSTITUCIONES EDUCATIVAS DEL SISTEMA NACIONAL DE EDUCACIÓN </b> y a las Nuevas Reformatorias de la LOEI. <b>“El servicio de transporte escolar es opcional y facultativo para los señores Padres de Familia”</b>. Tiene una duración de 10 meses consecutivos que comprende cada año lectivo, reservándose la Operadora de transporte “El derecho de suspender el servicio” a los estudiantes que no hayan cancelado dentro de los diez primeros días de cada mes, el costo del servicio de transporte escolar.  <br><br> <b> AL FINALIZAR SU FICHA DE INSCRIPCIÓN ENCONTRARÁ LOS TÉRMINOS Y CONDICIONES DEL SERVICIO DE TRANSPORTE ESCOLAR. <br><br> YO COMO TITULAR Y RESPONSABLE DE LOS DATOS DE MI REPRESENTADO, AUTORIZO Al USO DE LOS DATOS PERSONALES CONFORME A LAS FINALIDADES ESTABLECIDAS EN LA LEY ORGÁNICA DE PROTECCIÓN DE DATOS PERSONALES. SU SEGURIDAD Y PRIVACIDAD ES NUESTRA PRIORIDAD. </b> </p>',
            showCloseButton: true,

            focusConfirm: false,
            confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Avanzar con el proceso',


        })
    }



    


    static informationColegioIntisana(title: string, text: string, confirmButtronText: string, compania: string) {
        return Swal.fire({
            title: '<strong style="color:black">Aprecidas familias <div> Colegio INTISANA</div></strong> ',
            width: 850,
            html:
                '<p style="color:black;font-size:13px;text-align: justify"></strong> Reciban un cordial saludo de quienes conformamos la Compañía de Transporte Escolar "'+compania+'" Operadora de Transporte Escolar, que este año lectivo 2022-2023 proveerá del servicio opcional de transporte a los estudiantes de la institución. A la vez que ponemos a su disposición esta plataforma digital que nos permitirá mejorar los trámites de inscripción para el servicio de transporte estudiantil, y si está de acuerdo agradecemos llenar la misma con toda la información solicitada para oficializar la inscripción de su representado. <br> <br><span style="font-weight: bold;"> IMPORTANTE</span> <br> En cumplimiento con el ACUERDO MINISTERIAL Nro. MINEDUC-MINEDUC-2018-00077-A que expide la NORMATIVA DE TRANSPORTE ESCOLAR PARA LAS INSTITUCIONES EDUCATIVAS DEL SISTEMA EDUCATIVO NACIONAL. <br><span style="font-weight: bold;"> Artículo 1 </span>.- Objeto.- El presente Acuerdo Ministerial tiene por objeto establecer lineamientos generales para garantizar la seguridad y la calidad en la prestación del servicio de transporte escolar en el Sistema Educativo Nacional, bajo el cumplimiento de los principios rectores del transporte, como el de libre competencia. <br> <span style="font-weight: bold;">Artículo 2</span>.- Ámbito.- Las disposiciones contenidas en el presente Acuerdo Ministerial son de cumplimiento obligatorio para todas las instituciones educativas fiscales, municipales, fiscomisionales y particulares del Sistema Educativo Nacional.   <br> <span style="font-weight: bold;">Artículo 3</span>.- Servicio de transporte escolar.- El servicio de transporte escolar constituye un servicio personalizado para estudiantes del Sistema Educativo Nacional que requieren de movilización, desde sus hogares o la parada correspondiente, hasta las instituciones educativas y viceversa, de acuerdo a la necesidad de cada estudiante.        <br>    <span style="font-weight: bold;"> Artículo 4</span>.- Operadora de transporte escolar.- Las operadoras de transporte escolar son personas jurídicas legalmente constituidas con sujeción a las leyes pertinentes y con permiso de operación vigente otorgado por la Agencia Nacional de Tránsito o por el gobierno autónomo descentralizado municipal o metropolitano que haya asumido las competencias de conformidad a la normativa vigente.                Las operadoras de transporte escolar deberán prestar un servicio de calidad garantizando la seguridad de los estudiantes.   <br>          <span style="font-weight: bold;">   Artículo 5</span>.- Prestación del servicio.- El servicio de transporte escolar que se preste en las instituciones educativas fiscales, municipales, fiscomisionales y particulares es opcional para los representantes de los estudiantes; quienes, para acceder al mismo, deben manifestar su voluntad expresa a través de la suscripción del respectivo convenio o contrato para la prestación del servicio de transporte escolar.</p> ',
            showCloseButton: true,

            focusConfirm: false,
            confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Avanzar con el proceso',


        })
    }


    static informationmap() {
        return Swal.fire({
            title: '<strong style="color:black">Instrucciones</strong>',
            icon: 'info',
            html:
                '<p style="color:black;font-size:15px;text-align: justify">Señor Padre de Familia: a continuación presentamos un croquis en el cual debe ubicar la dirección exacta de su domicilio o lugar de retiro y retorno de su representado, a fin de facilitar el reconocimiento por parte del señor transportista. <br><br><b>PASOS<b> <br>1.- Ingrese la dirección de su domicilio. <br>2.-  Ubique el puntero del mouse sobre el mapa y de un click, luego, arrastre el mapa hasta fijar el punto exacto de su domicilio. </p> <br><br><label style="color:black" > NOTA: "Su solicitud se confirmará de acuerdo a disponibilidad de rutas y sectores."</label>',
            showCloseButton: true,

            focusConfirm: false,
            confirmButtonText:
                '<i class="fa fa-thumbs-up"></i>Avanzar con el proceso',


        })
    }






    static informationmapHelp() {
        return Swal.fire({
            title: '<strong style="color:black">Instrucciones</strong>',

            html:
                '<p style="color:black;font-size:15px;text-align: justify">Estimado usuario seleccione el punto exacto de su domicio en el mapa.<br>    <img style="width:100%" src="../../assets/Videosgif/gifmapa.gif" alt="Funny image">   </p>',
            showCloseButton: true,
            confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Entendido',
            focusConfirm: false,

        })
    }




    




}
